<template>
  <Layout>
    <PageHeader :title="page.title" :items="page.items" />

    <!-- main -->
    <b-row>
      <b-col lg="12">
        <!-- 查询条件 -->
        <b-card>
          <b-row>
            <b-col lg="3">
              <b-form-group
                label="Account"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="account"
              >
                <b-form-input
                  id="account"
                  v-model="search_condition.username"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                label="Role"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="role"
              >
                <b-form-select
                  v-model="search_condition.roleId"
                  :options="types.roleList"
                  value-field="id"
                  text-field="roleName"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                label="Status"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="status"
              >
                <b-form-select
                  v-model="search_condition.status"
                  :options="types.statuss"
                  value-field="value"
                  text-field="text"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-button variant="primary" @click="search()">Search</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <!-- table -->
          <b-button
            v-has="'accounts::Create'"
            @click="gotoAdd"
            variant="primary"
            >Create</b-button
          >

          <div class="table-responsive mb-0">
            <b-table
              show-empty
              empty-text="no records"
              id="table"
              head-variant="light"
              ref="table"
              :busy="isBusy"
              :striped="true"
              :items="provider"
              :fields="fields"
              :per-page="search_condition.pageSize"
              :current-page="search_condition.pageNum"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-includedfields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(index)="data">
                {{
                  data.index +
                  (search_condition.pageNum - 1) * search_condition.pageSize +
                  1
                }}
              </template>

              <template v-slot:cell(nickName)="data">
                <img
                  v-if="data.item.picture"
                  :src="`${data.item.picture}`"
                  alt
                  class="avatar-xs rounded-circle mr-2"
                />
                {{ data.item.nickName }}
              </template>

              <template v-slot:cell(actions)="row">
                <b-button-group>
                  <b-button
                    v-has="'accounts::Modify'"
                    size="sm"
                    variant="info"
                    @click="edit(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    Modify
                  </b-button>
                  <!-- <b-button
                    v-if="!row.item.status"
                    v-has="'accounts::Disable'"
                    size="sm"
                    variant="danger"
                    @click="enableOrDisable(row.item, row.index, $event.target)"
                    class="mr-1"
                    >deplete</b-button
                  >

                  <b-button
                    v-else
                    v-has="'accounts::Enable'"
                    size="sm"
                    variant="info"
                    @click="enableOrDisable(row.item, row.index, $event.target)"
                    class="mr-1"
                    >enable</b-button
                  > -->
                </b-button-group>
              </template>
            </b-table>
          </div>
          <!-- end table -->
          <!-- pagination -->
          <b-row v-if="has_data">
            <b-col>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination mb-0" v-if="rows != 0">
                  <b-pagination
                    v-model="search_condition.pageNum"
                    :per-page="10"
                    :total-rows="rows"
                    aria-controls="table"
                  >
                  </b-pagination>
                </ul>
              </div>
            </b-col>
          </b-row>
          <!-- end pagination -->
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import timeZoneConversion from "@/components/widgets/timeZoneConversion";

/**
 * FAQ component
 */
export default {
  components: {
    Layout,
    PageHeader,
    DatePicker,
  },
  data() {
    return {
      page: {
        title: "Accounts",
        items: [
          {
            text: "UNI-CORE",
            // href: "/"
          },
          {
            text: "System Mgmt",
            // href: "/"
          },
          {
            text: "Accounts",
            active: true,
          },
        ],
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        { key: "username", label: "Account", class: "text-center" },
        { key: "nickName", label: "Nickname", class: "text-center" },
        { key: "roleName", label: "role", class: "text-center" },
        {
          key: "status",
          label: "Status",
          formatter: (value) => {
            return value == 0 ? "Enabled" : "Disabled";
          },
        },
        {
          key: "createTime",
          label: "Create Time",
          class: "text-center",
          formatter: (value) => {
            if (value) {
              return timeZoneConversion.getLocalTime(value);
            } else {
              return "";
            }
          },
        },
        { key: "fullName", label: "Created By", class: "text-center" },
        { key: "actions", label: "Opreration", class: "text-center" },
      ],
      search_condition: {
        pageNum: 1,
        pageSize: 10,
        username: "",
        roleId: "",
        status: "",
      },
      isBusy: false,
      has_data: false,
      types: {
        statuss: [
          { text: "Please select", value: "", disabled: false },
          { text: "Enabled", value: 0, disabled: false },
          { text: "Disabled", value: 1, disabled: false },
        ],
        roleList: [{ id: "", roleName: "Please select" }],
      },
    };
  },
  watch: {},
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {
    this.init();
  },
  created() {},
  methods: {
    init() {
      this.$api.Dropdown.selectRoleAllList().then((res) => {
        if (res.success) {
          this.types.roleList = this.types.roleList.concat(res.data);
        }
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    gotoAdd() {
      this.$router.push("systemAccountsAdd");
    },
    provider(ctx) {
      this.isBusy = true;
      return this.$api.systemManage
        .list(this.search_condition, ctx)
        .then((x) => {
          this.isBusy = false;
          if (x.total) {
            this.has_data = true;
            this.totalRows = x.total;
            return x.data;
          } else {
            this.has_data = false;
            return [];
          }
        })
        .catch((e) => {
          this.isBusy = false;
          this.has_data = false;
          return [];
        });
    },
    edit(item, index, button) {
      this.$router.push("systemAccountsEdit?id=" + item.id);
    },
    search() {
      this.search_condition.pageNum = 1;
      this.$refs.table.refresh();
    },
    // 停用启用
    enableOrDisable(a, b, c) {
      this.$api.systemManage
        .enableOrDisable({
          id: a.id,
          status: a.status === 0 ? 1 : 0,
        })
        .then((res) => {
          if (res.message) {
            this.$bvToast.toast(res.message);
          }
          if (res.success) {
            this.$refs.table.refresh();
          }
        });
    },
  },
};
</script>
